import { useFeatureEnabled } from "@/hooks/useOrganizationFeatures";

/**
 * Is the docked Ré bookkeeper available to this user in this org? The
 * `bookkeeper_ai` flag alone — Ré is open to every org role. What Ré can do
 * is filtered per role on the API (each tool carries the scope it requires;
 * a project manager gets no ledger tools), so the web never gates on
 * `accounting` here. One rule for the header toggle and the panel.
 */
export function useBookkeeperEnabled(): boolean {
  const { enabled } = useFeatureEnabled("bookkeeper_ai");
  return enabled;
}
